import Img1 from "../assets/images/porqueimg1.jpg"
import Img2 from "../assets/images/porqueimg2.jpg"
import Img3 from "../assets/images/porqueimg3.jpg"
import Img4 from "../assets/images/porqueimg4.jpg"
export default [
  {
    title: "EXPERIENCIA Y TRAYECTORIA",
    text:
      "Llevamos más de 15 años de reconocimiento en las carreteras nacionales",
    image: Img1,
  },
  {
    title: "INNOVACIÓN",
    text:
      "Nuestro sistema de ensamblaje modular permite la personalización y hace sostenible la innovación de nuestros vehículos",
    image: Img2,
  },
  {
    title: "RENDIMIENTO",
    text: "Carrocerías sólidas hechas para las carreteras del Perú",
    image: Img3,
  },
  {
    title: "GARANTÍA",
    text:
      "Estamos cada vez más cerca de nuestros clientes brindando atención personalizada",
    image: Img4,
  },
]
